import axios from '@fs/zion-axios'

const BASE_QUEUES_PATH = '/service/dmc/queues'

export async function getHolocaustReport(personId, userId) {
  const url = `${BASE_QUEUES_PATH}/holocaustReport?personId=${personId}&userId=${userId}`
  return axios.get(url).then((response) => {
    return response.data
  })
}

export async function getQueueFamily(personId) {
  const url = `${BASE_QUEUES_PATH}/familyDetails?personId=${personId}`
  return axios.get(url).then((response) => {
    return response.data
  })
}

// button actions

export async function queueButtonHolocaust(personId, labelName, cisId, reason) {
  const url = `${BASE_QUEUES_PATH}/queueButton/holocaust?personId=${personId}&labelName=${labelName}&cisId=${cisId}&reason=${reason}`
  return axios.put(url).then((response) => {
    return response.data
  })
}

export async function queueButtonNotHolocaust(personId, labelName, cisId, reason) {
  const url = `${BASE_QUEUES_PATH}/queueButton/notHolocaust?personId=${personId}&labelName=${labelName}&cisId=${cisId}&reason=${reason}`
  return axios.put(url).then((response) => {
    return response.data
  })
}

export async function queueButtonFamous(personId, labelName, cisId, reason) {
  const url = `${BASE_QUEUES_PATH}/queueButton/famous?personId=${personId}&labelName=${labelName}&cisId=${cisId}&reason=${reason}`
  return axios.put(url).then((response) => {
    return response.data
  })
}

export async function queueButtonAction(actionType, personId, cisId, type) {
  const url = `${BASE_QUEUES_PATH}/queueButton/${actionType}?personId=${personId}&cisId=${cisId}&type=${type}`
  return axios.put(url).then((response) => {
    return response.data
  })
}
